import { ACCESS_LEVELS, FEATURE_FLAGS } from '@/lib/consts.ts'

import { ACCESS_LEVEL_PERMISSION } from './const'
import { AccessLevelPermissionType } from './index'
import type { RuleParams } from './types'

type AccessRules = Record<AccessLevelPermissionType, (params: RuleParams) => boolean>

const rules: AccessRules = {
  [ACCESS_LEVEL_PERMISSION.allCalendars]: ({ accessLevel, overrides }) => {
    if ('calendar' in (overrides || {})
      && [ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.RECEPTION].includes(accessLevel)
    ) {
      return Boolean(overrides?.calendar)
    }
    return [ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.RECEPTION, ACCESS_LEVELS.OWNER].includes(accessLevel)
  },

  [ACCESS_LEVEL_PERMISSION.clientDetails]: ({ accessLevel, overrides }) => {
    if ('client_info' in (overrides || {})
      && [ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.RECEPTION].includes(accessLevel)
    ) {
      return Boolean(overrides?.client_info)
    }
    return [ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.RECEPTION, ACCESS_LEVELS.OWNER].includes(accessLevel)
  },

  [ACCESS_LEVEL_PERMISSION.checkout]: ({ accessLevel, overrides }) => {
    if ('checkout' in (overrides || {})
      && [ACCESS_LEVELS.STAFF].includes(accessLevel)
    ) {
      return Boolean(overrides?.checkout)
    }
    return [ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.RECEPTION, ACCESS_LEVELS.OWNER].includes(accessLevel)
  },

  [ACCESS_LEVEL_PERMISSION.waitlist]: ({ accessLevel, overrides, ff }) => {
    if (ff?.(FEATURE_FLAGS.Feature_WaitlistNewView)
      && accessLevel === ACCESS_LEVELS.RECEPTION
      && ('calendar' in (overrides || {}) || 'client_info' in (overrides || {}))
    ) {
      return Boolean(overrides?.calendar) && Boolean(overrides?.client_info)
    }
    return [ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.RECEPTION, ACCESS_LEVELS.OWNER].includes(accessLevel)
  },

  [ACCESS_LEVEL_PERMISSION.aiReceptionist]: ({ accessLevel, overrides }) => {
    if (('calendar' in (overrides || {}) || 'client_info' in (overrides || {}))
      && accessLevel === ACCESS_LEVELS.RECEPTION
    ) {
      return Boolean(overrides?.calendar) && Boolean(overrides?.client_info)
    }

    return [ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.RECEPTION, ACCESS_LEVELS.OWNER].includes(accessLevel)
  },
}

export default rules
